export default __webpack_public_path__ + "images/KK.2d168a1.png";